import {
    ApplicationInsights,
    SeverityLevel
} from '@microsoft/applicationinsights-web';

class AppInsights {
    appInsights: ApplicationInsights;
    instrumentationKey: string | undefined = process.env.REACT_APP_INSTRUMENTATION_KEY;
    confirmationNumber: string | undefined;

    constructor() {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: this.instrumentationKey,
                disableFetchTracking: false
            }
        });

        try {
            this.appInsights.loadAppInsights();
            this.appInsights.trackPageView();
        } catch (error) {
            console.log(error);
        }
    }

    logInfo(message: string): void {
        this.appInsights.trackTrace(
            {
                message: message,
                severityLevel: SeverityLevel.Information
            }
        );
    }
    
    logWarning(message: string): void {
        this.appInsights.trackTrace(
            {
                message: message,
                severityLevel: SeverityLevel.Warning
            }
        );
    }
    
    logError(message: string): void {
        this.appInsights.trackTrace(
            {
                message: message,
                severityLevel: SeverityLevel.Error
            }
        );
    }
}

export default new AppInsights();